"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Sunglasses16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "Sunglasses/16" },
            react_1.default.createElement("path", { id: "Icon", d: "M0.666667 5.66667C0.666667 5.66667 1.66667 5 4 5C5.15948 5 5.98972 5.16462 6.53162 5.33025C6.95274 5.12152 7.45745 5 8 5C8.54255 5 9.04726 5.12152 9.46838 5.33025C10.0103 5.16462 10.8405 5 12 5C14.3333 5 15.3333 5.66667 15.3333 5.66667C15.7015 5.66667 16 5.96514 16 6.33333C16 6.70152 15.7015 7 15.3333 7H15.1429L14.7891 9.47655C14.708 10.044 14.4829 10.5958 13.9363 10.7686C13.5361 10.8952 12.9253 11 12 11C11.0747 11 10.4639 10.8952 10.0637 10.7686C9.51711 10.5958 9.292 10.044 9.21094 9.47655L8.77989 6.45921C8.56059 6.38001 8.2912 6.33333 8 6.33333C7.7088 6.33333 7.43941 6.38001 7.22011 6.45921L6.78906 9.47655C6.708 10.044 6.48289 10.5958 5.93632 10.7686C5.53612 10.8952 4.92533 11 4 11C3.07467 11 2.46388 10.8952 2.06368 10.7686C1.51711 10.5958 1.292 10.044 1.21094 9.47655L0.857143 7H0.666667C0.298477 7 0 6.70152 0 6.33333C0 5.96514 0.298477 5.66667 0.666667 5.66667Z", fill: "#383F49" })));
}
function Sunglasses16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Sunglasses16Svg, Object.assign({}, svgProps)));
}
exports.default = Sunglasses16;
//# sourceMappingURL=Sunglasses16.js.map